import _extends from'@babel/runtime/helpers/extends';import _toConsumableArray from'@babel/runtime/helpers/toConsumableArray';import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React,{useRef,useMemo,useCallback,useEffect}from'react';import {useIntl}from'react-intl';import dayjs from'dayjs';import PropTypes from'prop-types';import {DateOfBirthExperimental}from'@manulife/mux';import muxCustomStyles from'../../customStyles/index.js';import useValidation from'../../hooks/useValidation.js';import {dateOfBirthDayValidations,dateOfBirthMonthValidations,dateOfBirthYearValidations}from'../../utils/validation.js';var DateOfBirth = function DateOfBirth(_ref) {
  var _dayInputRef$current;
  var dateOfBirthParts = _ref.dateOfBirthParts,
    dateOfBirth = _ref.dateOfBirth,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, ["dateOfBirthParts", "dateOfBirth", "onChange"]);
  var intl = useIntl();
  var dayInputRef = useRef();
  var monthInputRef = useRef();
  var yearInputRef = useRef();
  var _useValidation = useValidation(dateOfBirthDayValidations, dateOfBirthParts.day, 'dob'),
    _useValidation2 = _slicedToArray(_useValidation, 3),
    dayValidationErrors = _useValidation2[0],
    setShowDayValidationErrors = _useValidation2[1],
    dayValidationResults = _useValidation2[2];
  var _useValidation3 = useValidation(dateOfBirthMonthValidations, dateOfBirthParts.month, 'dob', undefined, monthInputRef),
    _useValidation4 = _slicedToArray(_useValidation3, 2),
    monthValidationErrors = _useValidation4[0],
    setShowMonthValidationErrors = _useValidation4[1];
  var _useValidation5 = useValidation(dateOfBirthYearValidations, dateOfBirthParts.year, 'dob', undefined, yearInputRef),
    _useValidation6 = _slicedToArray(_useValidation5, 2),
    yearValidationErrors = _useValidation6[0],
    setShowYearValidationErrors = _useValidation6[1];
  var validationErrors = useMemo(function () {
    return [].concat(_toConsumableArray(dayValidationErrors), _toConsumableArray(monthValidationErrors), _toConsumableArray(yearValidationErrors));
  }, [dayValidationErrors, monthValidationErrors, yearValidationErrors]);
  var allPartsValid = validationErrors.length === 0;
  var invalidDate = allPartsValid && !dateOfBirth;

  // eslint-disable-next-line no-unused-expressions
  // eslint-disable-next-line prettier/prettier
  dayInputRef === null || dayInputRef === void 0 ? void 0 : (_dayInputRef$current = dayInputRef.current) === null || _dayInputRef$current === void 0 ? void 0 : _dayInputRef$current.setCustomValidity(
  // NOSONAR
  _toConsumableArray(dayValidationResults).length > 0 || invalidDate ? 'error' : '');
  var setShowValidations = useCallback(function (show) {
    setShowDayValidationErrors(show);
    setShowMonthValidationErrors(show);
    setShowYearValidationErrors(show);
  }, [setShowDayValidationErrors, setShowMonthValidationErrors, setShowYearValidationErrors]);

  // When the form that this element belongs to is submited, show validation errors
  useEffect(function () {
    var input = dayInputRef === null || dayInputRef === void 0 ? void 0 : dayInputRef.current;
    var form = input === null || input === void 0 ? void 0 : input.form;
    if (form) {
      var handleSubmit = function handleSubmit() {
        return setShowValidations(true);
      };
      form.addEventListener('submit', handleSubmit);
      return function () {
        return form.removeEventListener('submit', handleSubmit);
      };
    }
    return undefined;
  }, [dayInputRef, setShowValidations]);
  var handleChange = function handleChange(value) {
    onChange(value);
  };
  var invalidDateLabel = intl.formatMessage({
    id: 'shared.dateofbirth.invalidDate'
  });
  var beyondMinLabel = intl.formatMessage({
    id: 'shared.dateofbirth.reasonableAge'
  });
  var DATE_OF_BIRTH_UPPER_LIMIT = 120;
  var DATE_OF_BIRTH_LOWER_LIMIT = 14;
  return /*#__PURE__*/React.createElement(DateOfBirthExperimental, _extends({}, rest, {
    customStyle: muxCustomStyles.dateOfBirth,
    value: dateOfBirthParts,
    onChange: handleChange,
    errors: validationErrors,
    callouts: true,
    dayInputRef: dayInputRef,
    monthInputRef: monthInputRef,
    yearInputRef: yearInputRef,
    onBlur: function onBlur() {
      return setShowValidations(true);
    },
    invalidDateLabel: invalidDateLabel,
    beyondMinLabel: beyondMinLabel,
    beyondMaxLabel: invalidDateLabel,
    disabledDays: {
      before: dayjs().startOf('day').subtract(DATE_OF_BIRTH_UPPER_LIMIT, 'years').toDate(),
      after: dayjs().startOf('day').subtract(DATE_OF_BIRTH_LOWER_LIMIT, 'year').toDate()
    }
  }));
};
process.env.NODE_ENV !== "production" ? DateOfBirth.propTypes = {
  dateOfBirthParts: PropTypes.shape({
    // TODO
    day: PropTypes.string,
    month: PropTypes.string,
    year: PropTypes.string
  }).isRequired,
  dateOfBirth: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
} : void 0;
var DateOfBirth$1 = DateOfBirth;export{DateOfBirth$1 as default};